module.exports = __webpack_public_path__ + "static/img/counp1.eaa99dcd.png";